module.exports = __webpack_public_path__ + "static/timothy-murphy.a4b3e632.webp";